import keyMirror from '../utils/keyMirror';

export const errorLabels = keyMirror(
  'missingGuideId',
  'invalidSuccessDeepLinkParamCount',
  'successDeepLinkParamEmpty',
  'errorBulkAddingInterests',
  'errorBulkRemovingInterests',
);
